import { SELECT_PBX_PLAN, SET_PBX_PLAN } from '../actions/HostedPbxActions'

const initialState = {
    HostedPbxPlan: {
        id: "FREE",
        price: 0,
    },
}

const HostedPbxReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_PBX_PLAN:
            return {
                ...state,
                HostedPbxPlan: action.newData,
            }
        case SELECT_PBX_PLAN:
            return {
                ...state,
                HostedPbxPlan: {
                    id: action.planId,
                    price: action.planPrice,
                }
            }
        default:
            return state;
    }
}

export default HostedPbxReducer;